import React from 'react'

/* doc
---
title: CardHeader
name: CardHeader
category: React - Bulma
parent: Card
---

A `CardHeader` component for adding header content to a `Card`.

Can mostly be used with the `CardHeaderTitle` and `CardHeaderIcon` components.

See [Bulma Documentation](http://bulma.io/documentation/components/card/) for reference and full options.
If one of the Bulma options isn't listed below, it may be added using the `className` prop.

```html_example
  <Card>
    <CardHeader>
      stuff
    </CardHeader>
  </Card>
```
*/
function CardHeader(props) {
  const { children, className, ...rest } = props

  const classes = [
    'card-header',
    className || '',
  ]

  return (
    <header {...rest} className={classes.join(' ')}>
      {children}
    </header>
  )
}

export default CardHeader
